import React from 'react';

type Props = {
    heading: string;
    children: React.ReactNode;
};

const SectionHeading = ({ heading, children }: Props) => {
    return (
        <div className="flex flex-col flex-wrap items-baseline md:flex-row md:gap-16">
            <h2 className="text-22 md:text-34">{heading}</h2>
            <div className="mb-8 flex flex-row gap-8">{children}</div>
        </div>
    );
};

export default SectionHeading;
